import styled from 'styled-components';

export const ButtonGroup = styled.div`
  margin-top: 36px;

  > button + button {
    margin-top: 8px;
  }
`;
